"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _Step = _interopRequireDefault(require("./Step"));
var _MobileStep = _interopRequireDefault(require("./MobileStep"));
var _useIsMobile = require("../../hooks/useIsMobile");
var _Box = _interopRequireDefault(require("../Box"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Stepper = ({
  selected,
  steps,
  withMobileLayout = true,
  bidirectional = false,
  withBox = true,
  boxType,
  onStepSelected,
  trackingName,
  trackingEvent
}) => {
  const isMobile = (0, _useIsMobile.useIsMobile)();
  const DesktopStepper = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StepperWrapper, {
    steps: steps.length,
    children: steps.map((step, index) => {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Step.default, {
          nr: step.nr,
          title: step.title,
          subTitle: step.subTitle,
          bidirectional: bidirectional,
          selected: step.nr <= selected,
          onClick: onStepSelected,
          trackingEvent: trackingEvent,
          trackingName: trackingName
        })
      }, index);
    })
  });
  const PolyStepper = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [!isMobile && /*#__PURE__*/(0, _jsxRuntime.jsx)(DesktopStepper, {}), isMobile && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MobileStep.default, {
      steps: steps,
      selected: selected
    })]
  });
  if (!withBox) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: withMobileLayout ? /*#__PURE__*/(0, _jsxRuntime.jsx)(PolyStepper, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(DesktopStepper, {})
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    type: boxType,
    children: withMobileLayout ? /*#__PURE__*/(0, _jsxRuntime.jsx)(PolyStepper, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(DesktopStepper, {})
  });
};
var _default = exports.default = Stepper;